<template>
  <div class="h-full flex relative">
    <el-card class="h-full mr-10px w-300px" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">栏目名称</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
      </div>
      <el-tree
        v-if="treeStandBy"
        ref="columnTree"
        :default-expand-all="defaultExpandAll"
        :data="treeData"
        class="h-[calc(100%-84px)] overflow-auto"
        :props="{
          children: 'child',
          label: 'name',
        }"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
        :filter-node-method="filterTree"
        :default-expanded-keys="defaultExpandIds"
        :current-node-key="currentNodeKey"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
      >
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1" :body-style="{ height: '100%', overflowY: 'auto' }">
      <div class="flex items-center flex-wrap">
        <el-input
          v-model="search.title"
          size="small"
          placeholder="标题名称"
          class="w-180px mr-10px mb-10px"
          clearable
        ></el-input>
        <el-input
          v-model="search.createName"
          size="small"
          placeholder="发布人"
          class="w-180px mr-10px mb-10px"
          clearable
        ></el-input>
        <el-select
          size="small"
          v-model="search.deptSource"
          placeholder="部门"
          class="mr-10px mb-10px"
          clearable
          filterable
        >
          <el-option
            v-for="item in orgList"
            :key="item.id"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="search.author"
          size="small"
          placeholder="作者"
          class="w-180px mr-10px mb-10px"
          clearable
        ></el-input>
        <el-date-picker
          v-model="search.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="发布时间"
          end-placeholder="发布时间"
          class="mr-10px mb-10px"
        ></el-date-picker>
        <el-date-picker
          v-model="search.creationTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="创建时间"
          end-placeholder="创建时间"
          class="mr-10px mb-10px"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchData" class="mb-10px">
          搜索
        </el-button>
        <el-button size="small" @click="reset" class="mb-10px">重置</el-button>
        <el-button
          size="small"
          :disabled="!currentNode.isLeaf"
          @click="exportFile"
          :loading="exportLoading"
          class="mb-10px"
          >导出</el-button
        >
      </div>
      <el-table
        border
        stripe
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        class="mt-10px"
        height="calc(100% - 150px)"
        ref="tableRef"
        :row-key="(record) => record.id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column
          label="标题名称"
          prop="title"
          show-overflow-tooltip
          min-width="200"
        ></el-table-column>
        <el-table-column
          label="发布栏目"
          prop="columnName"
          show-overflow-tooltip
          min-width="150"
        ></el-table-column>
        <el-table-column label="置顶等级" prop="isTop" width="120">
          <template slot-scope="scope">
            <!-- <el-switch
              v-model="scope.row.isTop"
              :disabled="disabledOperation('top')"
              @change="switchTop($event, scope.row)"
            >
            </el-switch> -->
            <el-select
              size="small"
              v-model="scope.row.isTop"
              :disabled="disabledOperation('top')"
              class="w-full"
              @change="switchTop($event, scope.row)"
            >
              <el-option
                v-for="item in topList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" prop="isEnable" width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isShow"
              :disabled="disabledOperation('show')"
              @change="switchShow($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="发布人" prop="creatorName" width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="部门"
          prop="deptSourceName"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作者"
          prop="authorName"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="creationTime"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          label="发布时间"
          prop="editPublishTime"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column label="访问次数" prop="numberViews" width="80"></el-table-column>
        <el-table-column label="操作" width="75" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="operateBtn(scope.row, 'read')">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.total"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
      >
      </el-pagination>
    </el-card>
    <addEdit
      class="absolute top-0 left-0 z-100 h-full w-full"
      @close="closeGathetTaskDig"
      @on-success="handleSaveSuccess"
      v-if="showAddEditDialog"
      :detailData="detailData"
      :columnId="columnId"
      :operationType="operationType"
    ></addEdit>
  </div>
</template>
<script>
import {
  ColumApi,
  ColumnTableApi,
  ColumnRightsApi,
  ColumnTableExportApi,
  ColumnTableSearchApi,
} from '@wiz-api/workbench'
import { OrganizationApi } from '@wiz-api/abp-identity'
import dayjs from 'dayjs'
import { downLoadBlob } from '@/assets/js/CommonDownload'
import { informationPublishMap } from '../../../js/config'

const columnTypes = informationPublishMap.column
const columnTextType = columnTypes.columnText // 文字栏目
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目

const columApi = new ColumApi()
const columnTableApi = new ColumnTableApi()
const columnRightsApi = new ColumnRightsApi()
const columnTableExportApi = new ColumnTableExportApi()
const organizationApi = new OrganizationApi()
const columnTableSearchApi = new ColumnTableSearchApi()

const addEdit = () => {
  return import('./Detail')
}
export default {
  name: 'columnPublishManagement',
  components: { addEdit },
  data() {
    return {
      search: {
        title: '',
        createName: '',
        date: [],
        deptSource: '',
        author: '',
        creationTime: [],
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      treeData: [],
      tableData: [],
      treeKeyword: '',
      // 默认展开
      defaultExpandIds: [''],
      // 分类树显隐
      treeStandBy: true,
      // 是否默认展开全部
      defaultExpandAll: false,
      treeLoading: false,
      tableLoading: false,
      currentNodeKey: '',
      selectedList: [],
      showAddEditDialog: false,
      detailData: {},
      currentNode: {},
      operationType: '',
      columnPermission: [],
      exportLoading: false,
      columnId: '',
      orgList: [],
      topList: [
        { label: '不置顶', value: 0 },
        { label: '置顶1', value: 5 },
        { label: '置顶2', value: 4 },
        { label: '置顶3', value: 3 },
        { label: '置顶4', value: 2 },
        { label: '置顶5', value: 1 },
      ],
    }
  },
  created() {
    this.getOrgData()
    this.getTreeData()
  },
  computed: {},
  watch: {
    treeKeyword() {
      this.$refs.columnTree.filter(this.treeKeyword)
    },
  },
  methods: {
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.orgList = res?.items[0].children
      }
    },
    async exportFile() {
      this.exportLoading = true
      const params = {
        title: this.search.title,
        createName: this.search.createName,
        columnId: this.currentNode && this.currentNode.id,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      }
      if (!_.isEmpty(this.search.date)) {
        params.publishStartTime = dayjs(this.search.date[0]).format('YYYY-MM-DD HH:mm:ss')
        params.publishEndTime = dayjs(this.search.date[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      params.ids = null
      if (this.selectedList.length) {
        params.ids = _.map(this.selectedList, (item) => {
          return item.id
        })
      }
      let apiRes
      if (this.currentNode.type === columnTextType) {
        apiRes = await columnTableExportApi.textExport({
          body: params,
        })
      } else if (this.currentNode.type === columnImgTextType) {
        apiRes = await columnTableExportApi.imageExport({
          body: params,
        })
      } else if (this.currentNode.type === columnVideoType) {
        apiRes = await columnTableExportApi.videoImport({
          body: params,
        })
      }
      if (apiRes && !apiRes[0]) {
        downLoadBlob({
          name: `${this.$route.meta.title}导出${dayjs().format('YYYYMMDDHHmmss')}.zip`,
          data: apiRes[1],
        })
      }
      this.exportLoading = false
    },
    searchData() {
      this.page.pageNo = 1
      this.selectedList = []
      this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      this.getList()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchData()
    },
    operateBtn(row, type) {
      this.operationType = type
      this.columnId = row.columnId || this.currentNode.id
      if (row.titleStyle) {
        if (typeof row.titleStyle === 'string') {
          row.titleStyle = JSON.parse(row.titleStyle)
        }
      } else {
        row.titleStyle = {
          color: '#000000',
          fontWeight: false,
        }
      }
      this.detailData = {
        ...row,
        deptSource: row.deptSource ? JSON.parse(row.deptSource) : [],
      }
      this.showAddEditDialog = true
    },
    async getTreeData() {
      const [err, res] = await columApi.tree(0, {
        isOnlyShowOwnRight: true,
      })
      if (!err) {
        this.treeData = res
        if (res.length) {
          this.currentNode = this.treeData[0]
          this.$nextTick(() => {
            this.$refs.columnTree.setCurrentKey(this.currentNode.id)
          })
          this.handleNodeClick(this.currentNode)
        }
      }
    },
    async getList() {
      const params = {
        title: this.search.title,
        createName: this.search.createName,
        author: this.search.author,
        deptSource: this.search.deptSource,
        columnId: this.currentNode && this.currentNode.id,
        header: {
          'wiz-sensitive-words': false,
        },
      }
      if (!_.isEmpty(this.search.date)) {
        params.publishStartTime = dayjs(this.search.date[0]).format('YYYY-MM-DD HH:mm:ss')
        params.publishEndTime = dayjs(this.search.date[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (!_.isEmpty(this.search.creationTime)) {
        params.startTime = dayjs(this.search.creationTime[0]).format('YYYY-MM-DD HH:mm:ss')
        params.endTime = dayjs(this.search.creationTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.tableLoading = true
      let err
      let res
      let authorField
      if (!this.currentNode.isLeaf) {
        ;[err, res] = await columnTableSearchApi.searchColumnTableWithFlow(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
        authorField = 'author'
      } else if (this.currentNode.type === columnTextType) {
        // 1 = 栏目为文字类型
        ;[err, res] = await columnTableApi.getTextColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
        authorField = 'textAuthorName'
      } else if (this.currentNode.type === columnImgTextType) {
        // 2 = 栏目为图文类型
        ;[err, res] = await columnTableApi.getImageColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
        authorField = 'textAuthorName'
      } else if (this.currentNode.type === columnVideoType) {
        // 3 = 栏目为视频类型
        ;[err, res] = await columnTableApi.getVideoColumnTable(
          this.page.pageNo,
          this.page.pageSize,
          params
        )
        authorField = 'videoAuthorName'
      }
      if (!err && res) {
        this.tableData = res.items.map((it) => {
          it.creationTime = dayjs(it.creationTime).format('YYYY-MM-DD HH:mm:ss')
          it.editPublishTime = it.editPublishTime
            ? dayjs(it.editPublishTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          it.authorName = it[authorField]
          return it
        })
        this.page.total = res && res.totalCount
      }
      this.tableLoading = false
    },
    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    handleNodeClick(node) {
      this.page.pageNo = 1
      this.currentNode = node
      this.selectedList = []
      this.$refs.tableRef.clearSelection()
      this.getList()
      this.getPermission(node)
    },
    handleSelectionChange(list) {
      this.selectedList = list
    },
    // 是否置顶的切换
    async switchTop(event, row) {
      const params = {
        ...row,
        // id: row.id,
        isTop: event,
        lastModificationTime: null,
      }
      const type = this.currentNode.isLeaf ? this.currentNode.type : row.type
      let apiRes = null
      // 1 = 栏目为文字类型
      if (type === columnTextType) {
        apiRes = await columnTableApi.updateTextColumnTable({ body: params })
      }
      // 2 = 栏目为图文类型
      if (type === columnImgTextType) {
        apiRes = await columnTableApi.updateImageColumnTable({ body: params })
      }
      // 3 = 栏目为视频类型
      if (type === columnVideoType) {
        apiRes = await columnTableApi.updateVideoColumnTable({ body: params })
      }
      if (!apiRes[0]) {
        this.$message.success('操作成功')
        this.getList()
        this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      }
    },
    // 是否显示的切换
    async switchShow(event, row) {
      const params = {
        ...row,
        // id: row.id,
        isShow: event,
        lastModificationTime: null,
      }
      const type = this.currentNode.isLeaf ? this.currentNode.type : row.type
      let apiRes = null
      // 1 = 栏目为文字类型
      if (type === columnTextType) {
        apiRes = await columnTableApi.updateTextColumnTable({ body: params })
      }
      // 2 = 栏目为图文类型
      if (type === columnImgTextType) {
        apiRes = await columnTableApi.updateImageColumnTable({ body: params })
      }
      // 3 = 栏目为视频类型
      if (type === columnVideoType) {
        apiRes = await columnTableApi.updateVideoColumnTable({ body: params })
      }
      if (!apiRes[0]) {
        this.$message.success('操作成功')
        this.getList()
        this.$refs.tableRef && this.$refs.tableRef.clearSelection()
      }
    },
    closeGathetTaskDig() {
      this.showAddEditDialog = false
    },
    handleSaveSuccess() {
      this.showAddEditDialog = false
      this.getList()
    },
    async getPermission(data) {
      const [err, res] = await columnRightsApi.getColumnRight({
        columnId: data.id,
      })
      if (!err) {
        this.columnPermission = JSON.parse(res)
      }
    },
    disabledOperation(string) {
      return !_.includes(this.columnPermission, string)
    },
  },
}
</script>
<style scoped lang="scss"></style>
